import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import DropDown from "../Dropdown/Dropdown";
import styles from "./PhoneInputWidget.module.css";
import Input from "../Input/Input";
import { handleFormInput } from "../../shared/utilities/validations";
import { phoneNumberFormatValidation } from "../../shared/utilities/common";
import * as countryRepo from "../../shared/repos/graphql/country";
import * as phoneService from "../../shared/utilities/phone";
// REDUX
import * as countryActions from '../../redux/actions/country';
import * as checkoutActions from '../../redux/actions/checkout';

const brandRefreshCaretDown = require('../PaymentWidget/PaymentMethodGroupExpander/imgs/brand-refresh-caret-down.svg');
const brandRefreshFieldErrorInfo = require('../PaymentWidget/PaymentInputs/PaymentInputCreditCardLegacy/imgs/brand-refresh-field-error-info.svg');

const BRAND_REFRESH_PHONE_INPUT_ID = 'brand-refresh-contact-phone-local';
const BRAND_REFRESH_PHONE_ERROR_ID = 'brand-refresh-contact-phone-error';

const defaultMask = "(###) ###-####";

class PhoneInputWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneCodes: [],
      selectOptions: [],
      phoneCode: "",
      phonePrefixId: "",
      phonePhone: "",
      telephone: "",
      currentPhoneMask: defaultMask,
      currentValidator: [],
    };
  }

  getPreferredPhonePrefixId = () => {
    const { selectedCountry, isCountrySelectActive } = this.props;
    const preferredPrefixId = selectedCountry && selectedCountry.phone_prefix_id;
    if (isCountrySelectActive && preferredPrefixId) {
      return preferredPrefixId;
    }
    return null;
  };

  buildStateFromPrefix = prefix => {
    if (!prefix) {
      return null;
    }
    return {
      phonePrefixId: String(prefix.id),
      phoneCode: prefix.code,
      currentPhoneMask: this.castMaskFormat(prefix.mask),
      currentValidator: prefix?.validators,
    };
  };

  resolveDropdownPrefixValue = () => {
    const { checkout } = this.props;
    const { phonePrefixId, phoneCodes, phoneCode } = this.state;
    if (checkout?.phonePrefixId) {
      return String(checkout.phonePrefixId);
    }
    if (phonePrefixId) {
      return String(phonePrefixId);
    }
    const dialCode = checkout?.phoneCode || phoneCode;
    if (dialCode && phoneCodes.length > 0) {
      const prefix = phoneService.findPhonePrefixByDialCode(
        dialCode,
        phoneCodes,
        this.getPreferredPhonePrefixId()
      );
      if (prefix) {
        return String(prefix.id);
      }
    }
    return dialCode || "";
  };

  componentDidMount = () => {
    this.getPhoneCodes().then(() => {
      const {code, phone, telephone} = this.props;
      const {phoneCodes} = this.state;
      if (code || phone) {
        this.setUpPhoneData(code, phone);
      } else if (telephone) {
        this.setupTelephone(telephone);
      } else if (phoneCodes.length > 0) {
        this.setupDefaultPhoneCode();
      }
    });
  };

  setUpPhoneData = (code, phone) => {
    const {phoneCodes} = this.state;
    const prefix = phoneService.findPhonePrefixByDialCode(
      code,
      phoneCodes,
      this.getPreferredPhonePrefixId()
    );
    const mask = prefix
      ? this.castMaskFormat(prefix.mask)
      : this.castMaskFormat(phoneService.detectMask(code, phoneCodes));
    const validator = prefix
      ? prefix?.validators
      : phoneService.detectValidator(code, phoneCodes);
    this.setState({
      phoneCode: code,
      phonePrefixId: prefix ? String(prefix.id) : "",
      phonePhone: phone,
      currentPhoneMask: mask,
      currentValidator: validator,
    });
  }

  setupDefaultPhoneCode = () => {
    const {phoneCodes} = this.state;
    const {selectedCountry, isCountrySelectActive} = this.props;
    if (phoneCodes.length > 0) {
      let isPhoneCodeFound = false;
      const countryPrefixId = selectedCountry && selectedCountry.phone_prefix_id;
      if (isCountrySelectActive && selectedCountry && countryPrefixId) {
        const phoneCode = _.find(phoneCodes, { id: countryPrefixId.toString() });
        if (phoneCode) {
          this.setState(this.buildStateFromPrefix(phoneCode));
          isPhoneCodeFound = true;
        }
      }
      if (isPhoneCodeFound === false) {
        this.setState(this.buildStateFromPrefix(phoneCodes[0]));
      }
    }
  }

  setupTelephone = (phone) => {
    const rawPhone = phoneService.detectPhone(phone);
    const code = phoneService.detectCountryCode(phone);
    const {phoneCodes} = this.state;
    let mask = defaultMask;
    let validator = [];
    let prefix = null;
    if (code) {
      prefix = phoneService.findPhonePrefixByDialCode(
        code,
        phoneCodes,
        this.getPreferredPhonePrefixId()
      );
      mask = prefix
        ? this.castMaskFormat(prefix.mask)
        : this.castMaskFormat(phoneService.detectMask(code, phoneCodes));
      validator = prefix
        ? prefix?.validators
        : phoneService.detectValidator(code, phoneCodes);
    }
    this.setState({
      telephone: phone,
      phoneCode: code,
      phonePrefixId: prefix ? String(prefix.id) : "",
      phonePhone: rawPhone,
      currentPhoneMask: mask,
      currentValidator: validator,
    });
  };

  getPhoneCodes = () => {
    const {setPhonePrefixes, phonePrefixes} = this.props;
    const promise = new Promise((resolve) => {
      if (phonePrefixes.length > 0 && phonePrefixes[0].validators) {
        this.updatePhonePrefixes(phonePrefixes, resolve);
      } else {
        countryRepo.getPhonePrefixes().then((res) => {
          setPhonePrefixes(res.data.phonePrefixes);
          this.updatePhonePrefixes(res.data.phonePrefixes, resolve);
        });
      }
    });

    return promise;
  };

  updatePhonePrefixes = (prefixes, resolve) => {
    const options = _.map(prefixes, (optionCode) => {
      return {
        value: String(optionCode.id),
        label: `${optionCode.code}`,
      };
    });
    this.setState({
      selectOptions: options,
      phoneCodes: prefixes,
    }, () => {
      const {phoneCodes} = this.state;
      resolve(phoneCodes);
    });
  }

  validateMask = (mask, phone) => {
    const maskLength = mask.split("#").length - 1;
    return phone.length === maskLength;
  }

  additionalValidations = (validators, phone) => {
    let success = [];
    if (validators?.length) {
      success = _.map(validators, (validator) => {
        switch (validator.type) {
          case 'regex':
            return this.checkRegExp(validator, phone);
          default:
            return true;
        }
      });
    }
    success = _.filter(success, (suc) => {
      return suc !== true;
    })
    return (success.length > 0) ? success[0] : true;
  }

  checkRegExp = (validator, phone) => {
    const pattern = new RegExp(validator.rule);
    return pattern.test(phone) ? true : validator.error
  }

  componentDidUpdate = (prevProps, prevState) => {
    const {phonePhone, phoneCode, telephone, currentPhoneMask, currentValidator} = this.state;
    const {onInput} = this.props;
    if (
      prevState.phonePhone !== phonePhone ||
      prevState.phoneCode !== phoneCode
    ) {
      this.updatePhoneNumber(phoneCode, phonePhone);
    }
    if (prevState.telephone !== telephone) {
      const phone = phonePhone.replace(/\D/g, "");
      onInput({
        telephone: (phone && phone.trim() !== '') ? telephone : '',
        phone,
        code: phoneCode,
        mask: currentPhoneMask,
        validator: currentValidator,
        maskValidation: this.validateMask(currentPhoneMask, phonePhone.replace(/\D/g, "")),
        additionalValidations: this.additionalValidations(currentValidator, phone),
      });
    }
    this.onPropsTelephoneUpdate(prevProps.telephone);
  };

  onPropsTelephoneUpdate = (prevPhone) => {
    const {telephone} = this.props;
    if (prevPhone && prevPhone !== telephone) {
      const prefix = phoneService.detectCountryCode(telephone);
      const postfix = phoneService.detectPhone(telephone);
      if (prefix) {
        const { phoneCodes } = this.state;
        const prefixRow = phoneService.findPhonePrefixByDialCode(
          prefix,
          phoneCodes,
          this.getPreferredPhonePrefixId()
        );
        this.setState({
          phonePhone: postfix,
          phoneCode: prefix,
          phonePrefixId: prefixRow ? String(prefixRow.id) : "",
        });
      } else {
        this.setState({
          phonePhone: postfix,
        });
      }
    }
  }

  updatePhoneNumber = (prefix, phone) => {
    this.setState({
      telephone: prefix ? `${prefix} ${phone.replace(/\D/g, "")}` : `${phone.replace(/\D/g, "")}`,
    });
  };

  dropDownChange = (e) => {
    const { phoneCodes, telephone, phonePhone } = this.state;
    const { handleOnBlur, checkoutUpdated, checkout } = this.props;
    const prefix = phoneService.findPhonePrefixByOptionValue(e.value, phoneCodes);
    if (!prefix) {
      return;
    }
    const mask = this.castMaskFormat(prefix.mask);
    const validator = prefix?.validators;

    checkout.phoneCode = prefix.code;
    checkout.phonePrefixId = String(prefix.id);
    checkoutUpdated(checkout);

    this.setState(this.buildStateFromPrefix(prefix), () => {
      const phone = phonePhone.replace(/\D/g, "");
      handleOnBlur({
        telephone: (phone && phone.trim() !== '') ? telephone : '',
        phone,
        code: prefix.code,
        validator,
        mask,
        maskValidation: this.validateMask(mask, phonePhone.replace(/\D/g, "")),
        additionalValidations: this.additionalValidations(validator, phone),
      });
    });
  };

  castMaskFormat = (mask) => {
    return mask ? mask.replace(/\d/g, "#") : defaultMask;
  };

  handleOnBlur = () => {
    const {handleOnBlur} = this.props;
    const {telephone, phoneCode, phonePhone, currentPhoneMask, currentValidator} = this.state;
    const phone = phonePhone.replace(/\D/g, "");
    handleOnBlur({
      telephone: (phone && phone.trim() !== '') ? telephone : '',
      phone,
      code: phoneCode,
      mask: currentPhoneMask,
      validator: currentValidator,
      maskValidation: this.validateMask(currentPhoneMask, phonePhone.replace(/\D/g, "")),
      additionalValidations: this.additionalValidations(currentValidator, phone),
    });
  }

  phoneInputWidgetContainer = () => {
    const { phonePhone, currentPhoneMask, selectOptions, currentValidator } = this.state;
    const {
      className,
      customSelectStyles,
      label,
      customInputStyles,
      customInputContainerStyles,
      errorMessage,
      isEdit,
      isRequired,
      disabled,
      brandRefresh,
    } = this.props;

    const countryDropDown = (
      <DropDown
        disabled={disabled}
        onChange={(e) => this.dropDownChange(e)}
        options={selectOptions}
        value={this.resolveDropdownPrefixValue()}
        isRequired={isRequired}
        theme={!isEdit ? 'Dark' : 'Light'}
        compactLayout={brandRefresh}
        customDropDownStyles={
          brandRefresh ? '' : [styles.dropDownPlaceholder].join(' ')
        }
        className={[
          brandRefresh ? null : styles.selectStyle,
          brandRefresh ? styles.brandRefreshCountryDropdown : customSelectStyles,
          disabled ? 'isDisabled' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        ariaLabel="Country code"
      />
    );

    const brandRefreshPhoneLabelText = label || 'Phone Number';

    const phoneInput = (
      <Input
        disabled={disabled}
        inputId={brandRefresh ? BRAND_REFRESH_PHONE_INPUT_ID : undefined}
        ariaDescribedBy={brandRefresh && errorMessage ? BRAND_REFRESH_PHONE_ERROR_ID : undefined}
        customInputContainerStyles={customInputContainerStyles}
        customContainerStyles={[
          styles.inputStyle,
          styles.customInputWrapperLight,
          customInputStyles,
          brandRefresh ? styles.brandRefreshPhoneInputWrap : '',
        ]
          .filter(Boolean)
          .join(' ')}
        handleInput={(e) => handleFormInput(e, this, 'phonePhone')}
        label={brandRefresh ? '' : label}
        handleOnBlur={(e) => this.handleOnBlur(e)}
        placeholder=" "
        theme={!isEdit ? 'Dark' : 'Light'}
        value={phonePhone}
        inputMask={currentPhoneMask}
        validator={currentValidator}
        isNumberFormat
        isAllowed={phoneNumberFormatValidation}
        errorMessage={brandRefresh ? null : errorMessage}
        isRequired={isRequired}
      />
    );

    if (brandRefresh) {
      return (
        <div className={[styles.dropDownRow, styles.brandRefreshPhoneRow, className].join(' ')}>
          <div className={styles.brandRefreshCountryPill}>
            <div className={styles.brandRefreshCountryMain}>
              <span className={styles.brandRefreshCountryLabel}>
                Country Code
                {' '}
                <span className={styles.brandRefreshRequired}>*</span>
              </span>
              <div className={styles.brandRefreshCountryValue}>
                {countryDropDown}
              </div>
            </div>
            <img
              className={styles.brandRefreshCountryCaret}
              src={brandRefreshCaretDown}
              alt=""
              aria-hidden="true"
            />
          </div>
          <div className={styles.brandRefreshPhoneField}>
            <div
              className={[
                styles.brandRefreshPhonePill,
                phonePhone ? styles.brandRefreshPhonePillFilled : null,
                errorMessage ? styles.brandRefreshPhonePillHasError : null,
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <span
                className={
                  phonePhone
                    ? styles.brandRefreshCountryLabel
                    : styles.brandRefreshFieldGhost
                }
                aria-hidden="true"
              >
                {brandRefreshPhoneLabelText}
                {' '}
                <span className={styles.brandRefreshRequired}>*</span>
              </span>
              <div className={styles.brandRefreshPhoneInputHost}>
                {phoneInput}
              </div>
            </div>
            {errorMessage ? (
              <div
                id={BRAND_REFRESH_PHONE_ERROR_ID}
                className={styles.brandRefreshFieldErrorRow}
                role="alert"
              >
                <img
                  className={styles.brandRefreshFieldErrorInfo}
                  src={brandRefreshFieldErrorInfo}
                  alt=""
                  aria-hidden="true"
                />
                <p className={styles.brandRefreshFieldErrorText}>
                  {errorMessage}
                </p>
              </div>
            ) : null}
          </div>
        </div>
      );
    }

    return (
      <div className={[styles.dropDownRow, className].join(' ')}>
        {countryDropDown}
        {phoneInput}
      </div>
    );
  };

  render = () => {
    return <this.phoneInputWidgetContainer />;
  };
}
PhoneInputWidget.defaultProps = {
  telephone: "",
  code: "",
  phone: "",
  label: "",
  customInputStyles: "",
  customInputContainerStyles: "",
  customSelectStyles: "",
  errorMessage: "",
  className: "",
  isEdit: false,
  onInput: () => {},
  handleOnBlur: () => {},
  setPhonePrefixes: () => [],
  phonePrefixes: [],
  isRequired: false,
  isCountrySelectActive: false,
  disabled: false,
  brandRefresh: false,
};

PhoneInputWidget.propTypes = {
  disabled: PropTypes.bool,
  telephone: PropTypes.string,
  code: PropTypes.string,
  phone: PropTypes.string,
  label: PropTypes.string,
  customInputStyles: PropTypes.string,
  customInputContainerStyles: PropTypes.string,
  customSelectStyles: PropTypes.string,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  onInput: PropTypes.func,
  handleOnBlur: PropTypes.func,
  isEdit: PropTypes.bool,
  setPhonePrefixes: PropTypes.func,
  phonePrefixes: PropTypes.arrayOf(PropTypes.object),
  isRequired: PropTypes.bool,
  isCountrySelectActive: PropTypes.bool,
  brandRefresh: PropTypes.bool,
  checkout: PropTypes.shape().isRequired,
  checkoutUpdated: PropTypes.func.isRequired,
  selectedCountry: PropTypes.shape(
    {
      id: PropTypes.number,
      name: PropTypes.string,
      path_url: PropTypes.string,
      api_url: PropTypes.string,
      short_name: PropTypes.string,
      url: PropTypes.string,
      zone_id: PropTypes.string,
      phone_prefix_id: PropTypes.number,
      currency: {
          code: PropTypes.string,
          name: PropTypes.string,
          symbol: PropTypes.string,
        }
    }
  ).isRequired,

};

export const mapStateToProps = (state) => {
  const { phonePrefixes, selectedCountry, isCountrySelectActive } = state.country;
  return { phonePrefixes, selectedCountry, isCountrySelectActive, checkout: state.checkout };
};

export const mapDispatchToProps = (dispatch) => ({
  setPhonePrefixes: (value) => dispatch(countryActions.setPhonePrefixes(value)),
  checkoutUpdated: (value) => dispatch(checkoutActions.checkoutUpdated(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PhoneInputWidget);
